import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // Corrected import for jwt-decode
import Cookies from "js-cookie"; // Import the js-cookie library
import Loading from "../components/Loading";
import { toast } from "react-toastify";
import { getAllPets, getPetsByOwner } from "../services/api";
import {
  getAllAppointments,
  getAppointmentsByOwner,
} from "../services/appointmentApi";
import { getAllDoctors } from "../services/doctorApi";
import API from "../services/interceptor";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // *********** Login User ***********
  const [loginUser, setLoginUser] = useState(null);
  const [loginLoading, setLoginLoading] = useState(true);

  // *********** User Details  ***********
  const [userDetails, setUserDetails] = useState(null);
  const [userDetailsLoading, setUserDetailsLoading] = useState(false);
  const [userDetailsError, setUserDetailsError] = useState("");

  // *********** User Details  ***********
  const [doctorDetails, setDoctorDetails] = useState(null);
  const [doctorDetailsLoading, setDoctorDetailsLoading] = useState(false);
  const [doctorDetailsError, setDoctorDetailsError] = useState("");

  // *********** Pets ***********
  const [pets, setPets] = useState(null);
  const [petLoading, setPetLoading] = useState(false);
  const [petError, setPetError] = useState("");

  // *********** All Pets (Admin/Staff view) ***********
  const [allPets, setAllPets] = useState(null);
  const [allPetsLoading, setAllPetsLoading] = useState(false);
  const [allPetsError, setAllPetsError] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  /// *********** Appointments ***********
  const [appointments, setAppointments] = useState(null);
  const [appointmentLoading, setAppointmentLoading] = useState(false);
  const [appointmentError, setAppointmentError] = useState("");

  // *********** All Appointments (Admin/Staff view) ***********
  const [allAppointments, setAllAppointments] = useState(null);
  const [allAppointmentsLoading, setAllAppointmentsLoading] = useState(false);
  const [allAppointmentsError, setAllAppointmentsError] = useState("");

  // *********** Doctors ***********
  const [doctors, setDoctors] = useState([]);
  const [doctorLoading, setDoctorLoading] = useState(false);
  const [doctorError, setDoctorError] = useState("");

  // *********** Service Charge ***********
  const [serviceCharge, setServiceCharge] = useState(null);
  const [serviceChargeLoading, setServiceChargeLoading] = useState(false);
  const [serviceChargeError, setServiceChargeError] = useState("");

  // Check for token and user data in cookies when the component mounts
  useEffect(() => {
    const token = Cookies.get("token");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds

        // Check if token is expired
        if (decodedToken.exp < currentTime) {
          logout(); // Token is expired, log out the user
        } else {
          setLoginUser(decodedToken); // Set user info from the decoded token
        }
      } catch (error) {
        console.error("Invalid token", error);
        logout(); // Logout in case of invalid token
      }
    }
    setLoginLoading(false); // Set loading to false after the check is complete
  }, []);

  // ***************** Login *****************
  const login = (token) => {
    Cookies.set("token", token, { expires: 7 }); // Set the token in cookies with an expiration of 7 days

    try {
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);
      setLoginUser(decodedToken);
    } catch (error) {
      console.error("Invalid token provided during login", error);
    }
  };

  //************get user details************ */
  const getUserDetails = async () => {

    try {
      setUserDetailsLoading(true);
      setUserDetailsError("");

      const response = await API.get(`/api/user/${loginUser.id}`);
      setUserDetails(response.data);

    } catch (err) {
      setUserDetailsError(err.message || "Failed to fetch pets");
      setUserDetails(null);
    } finally {
      setUserDetailsLoading(false);
    }
  };

  //************get Doctor details************ */
  const getDoctorDetails = async () => {
    try {
      setDoctorDetailsLoading(true);
      setDoctorDetailsError("");

      const response = await API.get(`/api/user/doctor/${loginUser.id}`);
      setDoctorDetails(response.data.doctorDetails);

      console.log("DoctorDetails: ", doctorDetails);
      console.log("response.data: ", response.data);
    } catch (err) {
      setDoctorDetailsError(err.message || "Failed to fetch pets");
      setDoctorDetails(null);
    } finally {
      setDoctorDetailsLoading(false);
    }
  };

  //***************** Pets */
  const getPets = async () => {
    try {
      setPetLoading(true);
      setPetError("");

      const response = await getPetsByOwner(loginUser.id);

      if (response.success) {
        setPets(response.data || []);
      } else {
        setPetError(response.message || "Failed to fetch pets");
        setPets([]);
      }
    } catch (err) {
      setPetError(err.message || "Failed to fetch pets");
      setPets([]);
    } finally {
      setPetLoading(false);
    }
  };

  // ***************** All Pets (with filtering and pagination) *****************
  const getAllPet = async (queryParams = {}) => {
    try {
      setAllPetsLoading(true);
      setAllPetsError("");

      const response = await getAllPets(queryParams);
      console.log("getAllPets response:", response);

      // Handle the response structure with success and data properties
      if (response.success && response.data) {
        setAllPets(response.data);
        setTotalPages(
          response.totalPages ||
            Math.ceil(response.data.length / (queryParams.limit || 12)) ||
            1
        );
      } else {
        // Fallback for different response structures
        const petsData = response.pets || response.data || response;
        setAllPets(Array.isArray(petsData) ? petsData : []);
        setTotalPages(response.totalPages || 1);
      }
    } catch (err) {
      console.error("Error fetching all pets:", err);
      setAllPetsError(err.message || "Failed to fetch all pets");
      setAllPets([]);
      setTotalPages(1);
    } finally {
      setAllPetsLoading(false);
    }
  };

  // Appoinments for owner
  const getPetAppointment = async () => {
    console.log("loginUser: ", loginUser);

    try {
      setAppointmentLoading(true);
      setAppointmentError("");

      const response = await getAppointmentsByOwner(loginUser.id);
      console.log("getAppointmentsByOwner: ", response.data);

      if (response.success) {
        setAppointments(response.data || []);
      } else {
        setAppointmentError(response.message || "Failed to fetch appointments");
        setAppointments([]);
      }
    } catch (err) {
      setAppointmentError(err.message || "Failed to fetch appointments");
      setAppointments([]);
    } finally {
      setAppointmentLoading(false);
    }
  };

  // ***************** All Appointments (with filtering and pagination) doctor *****************
  // ***************** All Appointments (with filtering and pagination) doctor *****************
  // In your AuthContext, log the raw response:
  // In AuthContext.js - Update getAppointments function
  const getAppointments = async (queryParams = {}) => {
    try {
      setAllAppointmentsLoading(true);
      setAllAppointmentsError("");

      const response = await getAllAppointments(queryParams);
      console.log("getAllAppointments response:", response);

      if (response.success) {
        // Check if pets are populated
        if (response.data && response.data.length > 0) {
          const firstAppointment = response.data[0];
          if (
            firstAppointment.pets &&
            typeof firstAppointment.pets === "string"
          ) {
            console.warn(
              "Warning: Pets are not populated! Received ObjectId instead of pet object"
            );
          }
        }

        setAllAppointments(response.data || []);
      } else {
        setAllAppointmentsError(
          response.message || "Failed to fetch all appointments"
        );
        setAllAppointments([]);
      }
    } catch (err) {
      console.error("Error fetching all appointments:", err);
      setAllAppointmentsError(
        err.message || err || "Failed to fetch all appointments"
      );
      setAllAppointments([]);
    } finally {
      setAllAppointmentsLoading(false);
    }
  };

  // ***************** Doctors Context *****************
  const getDoctors = async (queryParams = {}) => {
    try {
      setDoctorLoading(true);
      setDoctorError("");

      const response = await getAllDoctors(queryParams);

      if (response.success) {
        setDoctors(response.data || []);
      } else {
        setDoctorError(response.message || "Failed to fetch doctors");
        setDoctors([]);
      }
    } catch (err) {
      setDoctorError(err.message || "Failed to fetch doctors");
      setDoctors([]);
    } finally {
      setDoctorLoading(false);
    }
  };

  // ***************** Service Charge Context *****************
  const getServiceCharge = async (queryParams = {}) => {
    try {
      setServiceChargeLoading(true);
      setServiceChargeError("");

      const response = await API.get("/api/servicecharge", {
        params: queryParams,
      });

      if (response.data.success) {
        setServiceCharge(response.data.data || []);
      } else {
        setServiceChargeError(
          response.data.message || "Failed to fetch service charge"
        );
        setServiceCharge([]);
      }
    } catch (err) {
      setServiceChargeError(err.message || "Failed to fetch service charge");
      setServiceCharge([]);
    } finally {
      setServiceChargeLoading(false);
    }
  };

  // ***************** Logout *****************
  const logout = () => {
    Cookies.remove("token"); // Remove the token from cookies
    setLoginUser(null);
  };

  if (loginLoading) {
    return <Loading />; // Render a loading state until token is checked
  }

  return (
    <AuthContext.Provider
      value={{
        loginUser,
        login,
        logout,

        getPets,
        pets,
        petLoading,
        petError,

        getPetAppointment,
        appointments,
        appointmentLoading,
        appointmentError,

        // Doctors
        getDoctors,
        doctors,
        doctorLoading,
        doctorError,

        // All appointments (admin/staff view)
        getAppointments,
        allAppointments,
        allAppointmentsLoading,
        allAppointmentsError,

        getAllPet,
        allPets,
        allPetsLoading,
        allPetsError,
        totalPages,

        // Add these new values
        getUserDetails,
        userDetails,
        userDetailsLoading,
        userDetailsError,

        getDoctorDetails,
        doctorDetails,
        doctorDetailsLoading,
        doctorDetailsError,

        // Service Charge
        getServiceCharge,
        serviceCharge,
        serviceChargeLoading,
        serviceChargeError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
